import React from 'react';
import MenuPageWrapper from '../Wrappers/MenuPageWrapper.jsx';

const Views = {
    Loading: "Loading",
    Home: "Home",
    MediaItem: "MediaItem",
    MediaItems: "MediaItems",
    Categories: "Categories",
    Category: "Category",
    Products: "Products",
    Calendar: "Calendar",
    Entitlements: "Entitlements"
}

export default class MoviesTVWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const menuItems = [
            { icon: "home", title: "Movies", href: "/cinema/" },
            { icon: "film", title: "Media Items", href: "/cinema/media_items" },
            { icon: "tv", title: "Media Products", href: "/cinema/products" },
            { icon: "calendar", title: "Categories", href: "/cinema/categories" },
            { icon: "ticket", title: "Coupons", href: "/cinema/coupons" },
            { icon: "money", title: "Sales", href: "/cinema/sales" },
            { icon: "eye", title: "Oculus IAP", href: "/cinema/iap" },
            { icon: "", title: "" },
            { icon: "home", title: "TV Home", href: "/tv/" },
            { icon: "video camera", title: "All Channels", href: "/tv/channels" },
            { icon: "video play", title: "Channel Groups", href: "/tv/channel_groups" },
            { icon: "video play", title: "Events", href: "/tv/events" }
        ];

        return (
            <MenuPageWrapper title={this.props.title || "Movies"} menuItems={menuItems} loading={this.props.loading}>
                {this.props.children}
            </MenuPageWrapper>
        );
    }
}
